<script setup lang="ts">
import { useDark, useToggle } from '@vueuse/core';

const isDark = useDark({
  valueDark: 'dark',
  valueLight: 'light'
});

const toggleAppearance = useToggle(isDark);
</script>

<template>
  <e-button
    as="button"
    aria-label="Toggle appearance"
    :icon="isDark ? 'moon' : 'sun'"
    @click="toggleAppearance()"
  />
</template>
